export const TRACKING_COMMENT_INPUT_HINT = 'social_overview_comment_click';
//# sourceMappingURL=tracking-constants.js.map